import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { applyMiddleware } from 'helpers/redux_dev_tools';
import thunk from 'redux-thunk';
import PropTypes from 'prop-types';

import AssignmentNavigator from './components/assignment_navigator';
import AssignmentPropTypes from './assignment_prop_types';
import { ProjectPropTypes } from 'components/project/prop_types';
import ContactRolePropTypes from 'bundles/project/prop_types/contact_roles';
import reducers from './reducers';

export default class AssignmentEditor extends Component {
  static propTypes = {
    ...AssignmentPropTypes,
    availableDatabaseOptions: PropTypes.arrayOf(PropTypes.array),
    canDestroyAssignment: PropTypes.bool.isRequired,
    canDuplicateAssignment: PropTypes.bool.isRequired,
    contactRoles: ContactRolePropTypes,
    defaultTaskAssignee: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    }),
    docTemplateOptions: PropTypes.array,
    editPath: PropTypes.string,
    features: PropTypes.shape({
      backoffice: PropTypes.bool,
      pipeline: PropTypes.bool,
      projectTasksActivities: PropTypes.bool
    }).isRequired,
    helpCenterUrl: PropTypes.string,
    project: ProjectPropTypes,
    royaltiesTabPath: PropTypes.string,
    surveyPropertyCsvColumns: PropTypes.object,
    surveysPath: PropTypes.string,
    tasksCsvPath: PropTypes.string,
    vouchersSearchPath: PropTypes.string
  };

  constructor(props) {
    super(props);

    const startingState = {
      assignment: props.assignment,
      availableDatabaseOptions: props.availableDatabaseOptions,
      contactRoles: props.contactRoles,
      docs: { marketing: { fetching: true }, nonMarketing: { fetching: true } },
      features: props.features,
      project: props.project,
      taskOptions: {},
      tasks: { fetching: true }
    };

    this.store = createStore(reducers, startingState, applyMiddleware(thunk));

    if (module.hot) {
      module.hot.accept('./reducers/index', () => {
        this.store.replaceReducer(require('./reducers/index'));
      });
    }
  }

  render() {
    return (
      <Provider store={this.store}>
        <AssignmentNavigator
          assignmentCsvPath={this.props.assignmentCsvPath}
          canDestroyAssignment={this.props.canDestroyAssignment}
          canDuplicateAssignment={this.props.canDuplicateAssignment}
          defaultTaskAssignee={this.props.defaultTaskAssignee}
          docTemplateOptions={this.props.docTemplateOptions}
          editPath={this.props.editPath}
          helpCenterUrl={this.props.helpCenterUrl}
          royaltiesTabPath={this.props.royaltiesTabPath}
          surveyPropertyCsvColumns={this.props.surveyPropertyCsvColumns}
          surveysPath={this.props.surveysPath}
          tasksCsvPath={this.props.tasksCsvPath}
          vouchersSearchPath={this.props.vouchersSearchPath}
        />
      </Provider>
    );
  }
}
